import React from 'react';
import { t } from '@base/utils/helpers';
import MainButton from '@ui-kit/components/mainButton';
import { ITable } from '@base/features/game/model/interfaces';
import { TablePoints } from '@base/features/lobby/component/tableListLayout/tableList/tablePoints/tablePoints';
import { InvitesListItem } from './invitesListItem';
import btn_ladder from '@base/assets/images/btn_ladder.svg';
import styles from '../styles/invitesList.module.scss';
import { IPlayer } from '@base/features/player/model/interfaces';

type PropsType = {
  tables: ITable[];
  children?: never;
  joinTable: (table: ITable) => void;
};

export const InvitesList = ({ tables, joinTable }: PropsType) => (
  <div className={styles.invites}>{renderTablesList(tables, joinTable)}</div>
);

function renderTablesList(tables: ITable[], startGame: (table: ITable) => void) {
  return tables.map((table: ITable) => {
    //если оба игрока есть, либо никого нет
    if ((table.seats[0] && table.seats[1]) || (!table.seats[0] && !table.seats[1])) return null;
    const player = table.seats[0] ? table.seats[0] : table.seats[1];
    return player ? renderTable(table, player, startGame) : null;
  });
}

function renderTable(table: ITable, player: IPlayer, joinTable: (table: ITable) => void) {
  const halfPoints = table.getMatchString();
  const fullPoints = {
    table: table.getNumber(),
    matchStringLong: table.getMatchStringLong(),
    timePerMoveStringL: table.getTimePerMoveString(0, '/move'),
  };

  return (
    <div className={styles.item} key={`${table.tid}`}>
      <InvitesListItem player={player} />
      <div className={styles.rating}>{player.rating}</div>
      <TablePoints halfPoints={halfPoints} fullPoints={fullPoints} />
      <div className={styles.ticket}>{table.getTicketString()}</div>
      <div className={styles.button}>
        <MainButton onClick={() => joinTable(table)}>
          <div className="table-list__play-ladder-wrap">
            {t('play')}
            <div>
              {table.ladder ? (
                <img className="table-list__play-ladder-img" src={btn_ladder} alt="icon ios" />
              ) : null}
            </div>
          </div>
        </MainButton>
      </div>
    </div>
  );
}
